import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { NonAuthenticatedGuard } from './core/guards/non-auth.guard';

const routes: Routes = [
	{
		path: 'auth',
		loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
		canLoad: [NonAuthenticatedGuard],
	},
	{
		path: '',
		loadChildren: () => import('./main/main.module').then((m) => m.MainModule),
		canLoad: [AuthGuard],
	},
	{
		path: '**',
		redirectTo: '/dashboard',
	},
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule],
})
export class AppRoutingModule {}
